module.exports = __webpack_public_path__ + "static/media/page header scenery 2.4a525d90.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/elements/page header scenery 2.svg
// module id = 54
// module chunks = 0